import axios from "axios";
import {
  ORG_REQUEST,
  ORG_SUCCESS,
  ORG_FAIL,
  ORG_CLEAR_ERRORS,
} from "../Constants/org_hierarchy_constants";

export const get_org_data = () => async (dispatch) => {
  try {
    dispatch({
      type: ORG_REQUEST,
    });
    const org_hierarchy = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/get-org-hirearchy-data/`
    );
    dispatch({
      type: ORG_SUCCESS,
      payload: org_hierarchy,
    });
  } catch (error) {
    dispatch({
      type: ORG_FAIL,
      payload: error.response,
    });
  }
};

export const org_data_clearErrors = () => async (dispatch) => {
  dispatch({
    type: ORG_CLEAR_ERRORS,
  });
};
